export interface TargetItem {
  id: string;
  targetType?: string | null;
  completionDate?: string | null;
  target?: {
    id?: string | null;
    name?: string | null;
    cover?: {uri?: string | null} | null;
  } | null;
}

// Valores observados na API: 'workout_group' e 'course_unit'. O TargetTypeEnum
// do schema declara 'unit', que nao aparece no dado real — por isso o mapa
// aceita os dois e nao depende do enum.
const TIPOS: Record<string, {label: string; icon: string}> = {
  workout_group: {label: 'Treino', icon: 'fa-dumbbell'},
  course_unit: {label: 'Aula', icon: 'fa-graduation-cap'},
  unit: {label: 'Aula', icon: 'fa-graduation-cap'},
};

export const tipoLegivel = (targetType?: string | null): string => TIPOS[targetType ?? '']?.label ?? '';

export const iconeDoTipo = (targetType?: string | null): string => TIPOS[targetType ?? '']?.icon ?? 'fa-star';

// Alvo apagado ou sem titulo aparece no dado real: um favorito da blacksheep
// vem com name null. Cair no tipo evita um card com o titulo em branco.
export const rotuloDoAlvo = (item: TargetItem): string => {
  const nome = item.target?.name?.trim();
  if (nome) return nome;

  return tipoLegivel(item.targetType) || 'Item removido';
};

export const capaDoAlvo = (item: TargetItem): string | null => item.target?.cover?.uri || null;

// completionDate chega como 'YYYY-MM-DD'. Montar com new Date(str) trataria a
// string como UTC e poderia recuar um dia no fuso do Brasil.
export const dataDeConclusao = (item: TargetItem): string => {
  const bruto = item.completionDate?.trim();
  if (!bruto) return '';

  const partes = bruto.slice(0, 10).split('-');
  if (partes.length !== 3) return '';

  const [ano, mes, dia] = partes;
  if (!/^\d{4}$/.test(ano) || !/^\d{2}$/.test(mes) || !/^\d{2}$/.test(dia)) return '';

  return `${dia}/${mes}/${ano}`;
};

// Rotas de detalhe registradas no nivel do app, e nao dentro de uma aba: o
// favorito pode apontar para um treino mesmo numa conta que tirou a aba de
// treinos da navegacao.
const ROTAS: Record<string, string> = {
  workout_group: 'treino',
  course_unit: 'aula',
  unit: 'aula',
};

// Alvo apagado chega sem id; sem destino, o card nao vira link.
export const rotaDoAlvo = (item: TargetItem): string | null => {
  const base = ROTAS[item.targetType ?? ''];
  const id = item.target?.id;

  if (!base || !id) return null;

  return `/${base}/${id}`;
};
